import React, { useEffect } from 'react';
import { Divider, Grid } from 'e100-react-components';
import { Typography } from 'shared/components';
import { useStyles } from './styles';

import { useSelectedCar } from 'features/myFleet';

import { Title } from './Title/Title';
import { Avatar } from './Avatar/Avatar';
import { useCarObuSerialnumberByAutoNumber, useReverseGeocode } from 'entities/cars';
import { Chips } from './Chips/Chips';
import { CarInformation } from './CarInformation/CarInformation';
import { ActiveServices } from './ActiveServices/ActiveServices';
import { RouteHistoryButton } from './RouteHistoryButton/RouteHistoryButton';

import { useIntl } from 'react-intl';

export const ObuCarDetails = () => {
  const classes = useStyles();
  const selectedCar = useSelectedCar()!;
  const { formatMessage } = useIntl();

  const { lastActivityDate, currentVehicle, batteryStatus } = selectedCar;
  const { weights, licensePlate } = currentVehicle;
  const { vehicleWeightUnladen } = weights;

  const getCarEBoxLocation = useCarObuSerialnumberByAutoNumber();
  const carEBoxLocation = getCarEBoxLocation(licensePlate);
  const { address, reverseGeocode } = useReverseGeocode();

  useEffect(() => {
    if (carEBoxLocation) {
      reverseGeocode(carEBoxLocation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carEBoxLocation]);


  return (
    <Grid
      container
      wrap='nowrap'
      direction='column'
      classes={{ root: classes.container }}
      spacing={0}
    >
      <Grid item>   
        <Grid
          container
          classes={{
            root: classes.contentRoot,
          }}
        >
          <Grid item xs={12}>
            <Title />
          </Grid>
          
          <Grid item xs={12} />
          <Grid item xs={12}>
            <Grid container spacing={0} justify="space-between" alignItems='center'>
              <Grid item>
                <Grid container spacing={0} direction="column">
                  <Grid item>
                    <Typography variant="h5" color="textPrimary" gutterBottom>
                      {licensePlate}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" color="textPrimary">
                      {`${formatMessage({ id: 'sourceInfo' })}: E-BOX`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Avatar vehicleWeightUnladen={vehicleWeightUnladen} licensePlate={licensePlate} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} />
          <Grid item xs={12}>
            <Chips
              address={address || ''}
              batteryCharge={Number(batteryStatus.value)}
              lastActivityDate={lastActivityDate}
            />
          </Grid>

          <Grid item xs={12} />
          <Grid item xs={12} />
          <Grid item xs={12} />
          <Grid item xs={12}>
            <CarInformation />
          </Grid>

          <Grid item xs={12}>
            <RouteHistoryButton />
          </Grid>

          <Grid item xs={12}>
            <Divider margin={{ left: -2, right: -2, top: 0, bottom: 1.5 }} />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle1">{formatMessage({ id: 'activatedServices' })}</Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item classes={{ root: classes.activeService }}>
        <ActiveServices />
      </Grid>
    </Grid>
  );
};
